$(function() {
    var initialCountry = 'us';
    switch($('html').attr('lang')) {
        case 'uk':
            initialCountry = 'ua';
            break;
        case 'ru':
            initialCountry = 'ua';
            break;
    }

    $(document).on('click', '.discuss-button', function(event) {
        event.preventDefault();
        $('#discuss-form .error-message').text('');
        $.ajax({
            url: "/discuss/add",
            type: "POST",
            data: $('#discuss-form').serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
            },
            success: function (response) {
                if (response.success) {
                    $('.discuss-name-input').val('');
                    $('.discuss-email-input').val('');
                    $('#successContactForm').modal('show');
                }
            },
            error: function (data) {
                for (let key in data.responseJSON.errors) {
                    $('.discuss-form-' + key + '-error').text(data.responseJSON.errors[key][0]);
                }
            }
        });
    });

    if ($('.review-slider-1').length > 0 && $('.review-slider-2').length > 0) {
        let swiper_review_slider_1 = new Swiper(".review-slider-1", {
            slidesPerView: 1,
            simulateTouch: false,
            shortSwipes: false,
            allowTouchMove: false
        });

        let swiper_review_slider_2 = new Swiper(".review-slider-2", {
            slidesPerView: 1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            }
        });

        swiper_review_slider_2.on('slideChangeTransitionStart', function (swiper) {
            swiper_review_slider_1.slideTo(swiper.activeIndex);
        });
    }

    $(document).on('click', '.send-contact', function(event) {
        event.preventDefault();
        $('#contact-form .error-message').text('');
        $.ajax({
            url: "/contact/send",
            type: "POST",
            data: $('#contact-form').serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
            },
            success:function(response){
                if (response.success) {
                    clearFrom('contact-form');
                    $('#contactForm').modal('hide');
                    $('#successContactForm').modal('show');
                }
            },
            error: function (data) {
                for (let key in data.responseJSON.errors) {
                    $('.contact-form-' + key + '-error').text(data.responseJSON.errors[key][0]);
                }
            }
        });
    });

    function clearFrom(form) {
        $('#' + form + ' .cleared').each(function() {
            $(this).val('');
        });
    }

    $(document).on('click', '.subscribe-form-btn', function(event) {
        event.preventDefault();
        $('.subscribe-form .error-message').text('');
        let form = $(this).parent().parent();
        $.ajax({
            url: "/subscribe",
            type: "POST",
            data: form.serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
            },
            success:function(response){
                if (response.success) {
                    $('.subscribe-form-email').val('');
                    $('#successContactForm').modal('show');
                }
            },
            error: function (data) {
                for (let key in data.responseJSON.errors) {
                    $('.subscribe-form-' + key + '-error').text(data.responseJSON.errors[key][0]);
                }
            }
        });
    });

    $(document).on('click', '.footer-subscribe-btn', function(event) {
        event.preventDefault();
        $('#footer-subscribe-form .error-message').text('');
        $.ajax({
            url: "/subscribe",
            type: "POST",
            data: $('#footer-subscribe-form').serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
            },
            success:function(response){
                if (response.success) {
                    $('.footer-subscribe-form-email').val('');
                    $('#successContactForm').modal('show');
                }
            },
            error: function (data) {
                for (let key in data.responseJSON.errors) {
                    $('.footer-subscribe-form-' + key + '-error').text(data.responseJSON.errors[key][0]);
                }
            }
        });
    });

    $(document).on('click', '.consultation-btn', function(event) {
        event.preventDefault();
        $('#consultation-form .error-message').text('');
        $.ajax({
            url: "/consultation/add",
            type: "POST",
            data: $('#consultation-form').serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
            },
            success:function(response){
                if (response.success) {
                    $('#consultation-form .cleared').val('');
                    $('#successContactForm').modal('show');
                }
            },
            error: function (data) {
                for (let key in data.responseJSON.errors) {
                    $('.consultation-form-' + key + '-error').text(data.responseJSON.errors[key][0]);
                }
            }
        });
    });

    if ($('#input-telephone').length) {
        var input = document.querySelector("#input-telephone");
        var iti = window.intlTelInput(input, {
            // allowDropdown: false,
            //autoInsertDialCode: true,
            // autoPlaceholder: "off",
            // dropdownContainer: document.body,
            // excludeCountries: ["us"],
            // formatOnDisplay: false,
            // geoIpLookup: function(callback) {
            //   fetch("https://ipapi.co/json")
            //     .then(function(res) { return res.json(); })
            //     .then(function(data) { callback(data.country_code); })
            //     .catch(function() { callback("us"); });
            // },
            hiddenInput: "phone",
            initialCountry: 'auto',
            geoIpLookup: callback => {
                fetch("https://ipapi.co/json")
                    .then(res => res.json())
                    .then(data => callback(data.country_code))
                    .catch(() => callback(initialCountry));
            },
            // localizedCountries: { 'de': 'Deutschland' },
            //nationalMode: false,
            // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
            // placeholderNumberType: "MOBILE",
            // preferredCountries: ['cn', 'jp'],
            separateDialCode: true,
            // showFlags: false,
            utilsScript: "/js/site/template/libs/intl/utils.js"
        });

        $(document).on('change', '#input-telephone', function () {
            $('input[name="phone"]').val(iti.getNumber());
        });

        input.addEventListener("countrychange", function() {
            $('input[name="phone"]').val(iti.getNumber());
        });
    }

    if ($('#input-telephone-advantages').length) {
        var input = document.querySelector("#input-telephone-advantages");
        var iti2 = window.intlTelInput(input, {
            // allowDropdown: false,
            //autoInsertDialCode: true,
            // autoPlaceholder: "off",
            // dropdownContainer: document.body,
            // excludeCountries: ["us"],
            // formatOnDisplay: false,
            // geoIpLookup: function(callback) {
            //   fetch("https://ipapi.co/json")
            //     .then(function(res) { return res.json(); })
            //     .then(function(data) { callback(data.country_code); })
            //     .catch(function() { callback("us"); });
            // },
            hiddenInput: "phone",
            initialCountry: 'auto',
            geoIpLookup: callback => {
                fetch("https://ipapi.co/json")
                    .then(res => res.json())
                    .then(data => callback(data.country_code))
                    .catch(() => callback(initialCountry));
            },
            // localizedCountries: { 'de': 'Deutschland' },
            //nationalMode: false,
            // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
            // placeholderNumberType: "MOBILE",
            // preferredCountries: ['cn', 'jp'],
            separateDialCode: true,
            // showFlags: false,
            utilsScript: "/js/site/template/libs/intl/utils.js"
        });

        $(document).on('change', '#input-telephone-advantages', function () {
            $('#advantages-form input[name="phone"]').val(iti2.getNumber());
        });

        input.addEventListener("countrychange", function() {
            $('#advantages-form input[name="phone"]').val(iti2.getNumber());
        });
    }

    if ($('#input-telephone-advantages-mobile').length) {
        var input = document.querySelector("#input-telephone-advantages-mobile");
        var iti3 = window.intlTelInput(input, {
            // allowDropdown: false,
            //autoInsertDialCode: true,
            // autoPlaceholder: "off",
            // dropdownContainer: document.body,
            // excludeCountries: ["us"],
            // formatOnDisplay: false,
            // geoIpLookup: function(callback) {
            //   fetch("https://ipapi.co/json")
            //     .then(function(res) { return res.json(); })
            //     .then(function(data) { callback(data.country_code); })
            //     .catch(function() { callback("us"); });
            // },
            hiddenInput: "phone",
            initialCountry: 'auto',
            geoIpLookup: callback => {
                fetch("https://ipapi.co/json")
                    .then(res => res.json())
                    .then(data => callback(data.country_code))
                    .catch(() => callback(initialCountry));
            },
            // localizedCountries: { 'de': 'Deutschland' },
            //nationalMode: false,
            // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
            // placeholderNumberType: "MOBILE",
            // preferredCountries: ['cn', 'jp'],
            separateDialCode: true,
            // showFlags: false,
            utilsScript: "/js/site/template/libs/intl/utils.js"
        });

        $(document).on('change', '#input-telephone-advantages-mobile', function () {
            $('#advantages-mobile-form input[name="phone"]').val(iti3.getNumber());
        });

        input.addEventListener("countrychange", function() {
            $('#advantages-mobile-form input[name="phone"]').val(iti3.getNumber());
        });
    }

    if ($('.main-expertise-slider').length > 0) {
        new Swiper(".main-expertise-slider", {
            slidesPerView: "auto",
            navigation: {
                nextEl: '.main-expertise-slide-next',
                prevEl: '.main-expertise-slide-prev',
            },
        });
    }

    if ($('.main-blog-slider').length > 0) {
        new Swiper(".main-blog-slider", {
            slidesPerView: "auto"
        });
    }

    if ($('#input-contact-telephone').length) {
        var input = document.querySelector("#input-contact-telephone");
        var iti4 = window.intlTelInput(input, {
            // allowDropdown: false,
            //autoInsertDialCode: true,
            // autoPlaceholder: "off",
            // dropdownContainer: document.body,
            // excludeCountries: ["us"],
            // formatOnDisplay: false,
            // geoIpLookup: function(callback) {
            //   fetch("https://ipapi.co/json")
            //     .then(function(res) { return res.json(); })
            //     .then(function(data) { callback(data.country_code); })
            //     .catch(function() { callback("us"); });
            // },
            hiddenInput: "phone",
            initialCountry: 'auto',
            geoIpLookup: callback => {
                fetch("https://ipapi.co/json")
                    .then(res => res.json())
                    .then(data => callback(data.country_code))
                    .catch(() => callback(initialCountry));
            },
            // localizedCountries: { 'de': 'Deutschland' },
            //nationalMode: false,
            // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
            // placeholderNumberType: "MOBILE",
            // preferredCountries: ['cn', 'jp'],
            separateDialCode: true,
            // showFlags: false,
            utilsScript: "/js/site/template/libs/intl/utils.js"
        });

        $(document).on('change', '#input-contact-telephone', function () {
            $('#contact-page-form input[name="phone"]').val(iti4.getNumber());
        });

        input.addEventListener("countrychange", function() {
            $('#contact-page-form input[name="phone"]').val(iti4.getNumber());
        });
    }

    $(document).on('click', '.contact-send-btn', function(event) {
        event.preventDefault();
        $('#contact-page-form .error-message').text('');
        $.ajax({
            url: "/contact/send",
            type: "POST",
            data: $('#contact-page-form').serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
            },
            success:function(response){
                if (response.success) {
                    clearFrom('contact-page-form');
                    $('#successContactForm').modal('show');
                }
            },
            error: function (data) {
                for (let key in data.responseJSON.errors) {
                    $('.contact-page-form-' + key + '-error').text(data.responseJSON.errors[key][0]);
                }
            }
        });
    });

    $(document).on('click', '.advantages-consultation-btn', function(event) {
        event.preventDefault();
        let id = $(this).attr('form');
        $('#' + id + ' .error-message').text('');

        sendAdvantagesConsultation(id);
    });

    function sendAdvantagesConsultation(id) {
        $.ajax({
            url: "/consultation/send",
            type: "POST",
            data: $('#' + id).serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
            },
            success:function(response){
                if (response.success) {
                    $('#' + id + ' .cleared').val('');
                    $('#advantages-mobile-form input[name="phone"]').val('');
                    $('#advantages-form input[name="phone"]').val('');
                    $('#successContactForm').modal('show');
                }
            },
            error: function (data) {
                for (let key in data.responseJSON.errors) {
                    $('.advantages-form-' + key + '-error').text(data.responseJSON.errors[key][0]);
                }
            }
        });
    }

    $(document).on('click', '.blog-load-more-btn', function() {
        let page = $(this).attr('next');

        let btn = $(this);

        $.ajax({
            url: "/get-articles?page=" + page + '&lang=' + $('html').attr('lang'),
            type: "GET",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
            },
            success:function(response){
                if (response.current_page == response.last_page) {
                    btn.css('display', 'none');
                } else {
                    btn.attr('next', response.current_page + 1);
                }

                for(let key in response.data) {
                    let read_time = response.data[key].min_to_read_text;
                    let date = response.data[key].date;
                    let url = response.data[key].full_url;
                    let title = response.data[key].translation ? response.data[key].translation.title : '';
                    let short_description = response.data[key].translation && response.data[key].translation.short_description ? response.data[key].translation.short_description : '';
                    let blog_read_btn = response.data[key].blog_read_btn;
                    let block_class = response.data[key].block_class;
                    let image = response.data[key].image;
                    let alt = response.data[key].translation ? response.data[key].translation.alt : '';

                    let dots = `<div class="blog-dots">
                            <svg width="405" height="154" viewBox="0 0 405 154" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.7">
                                    <circle cx="212.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="212.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="212.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="212.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="212.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="212.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="212.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="212.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="233.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="233.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="233.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="233.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="233.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="233.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="233.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="233.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="254.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="254.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="254.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="254.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="254.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="254.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="254.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="254.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="275.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="275.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="275.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="275.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="275.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="275.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="275.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="275.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="296.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="296.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="296.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="296.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="296.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="296.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="296.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="296.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="317.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="317.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="317.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="317.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="317.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="317.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="317.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="317.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="338.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="338.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="338.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="338.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="338.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="338.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="338.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="338.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="359.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="359.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="359.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="359.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="359.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="359.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="359.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="359.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="380.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="380.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="380.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="380.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="380.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="380.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="380.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="380.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="401.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="401.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="401.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="401.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="401.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="401.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="401.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="401.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="3.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="3.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="3.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="3.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="3.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="3.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="3.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="3.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="24.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="24.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="24.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="24.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="24.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="24.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="24.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="24.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="45.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="45.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="45.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="45.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="45.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="45.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="45.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="45.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="66.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="66.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="66.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="66.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="66.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="66.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="66.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="66.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="87.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="87.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="87.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="87.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="87.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="87.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="87.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="87.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="108.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="108.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="108.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="108.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="108.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="108.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="108.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="108.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="129.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="129.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="129.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="129.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="129.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="129.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="129.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="129.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="150.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="150.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="150.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="150.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="150.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="150.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="150.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="150.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="171.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="171.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="171.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="171.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="171.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="171.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="171.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="171.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="192.5" cy="3.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="192.5" cy="24.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="192.5" cy="45.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="192.5" cy="66.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="192.5" cy="87.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="192.5" cy="108.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="192.5" cy="129.5" r="3.5" fill="#0BB8FD"/>
                                    <circle cx="192.5" cy="150.5" r="3.5" fill="#0BB8FD"/>
                                </g>
                            </svg>

                        </div>`;


                    let html = `<div class="row blog-container ${block_class}">
                            <div class="col-md-6">
                                <div class="blog-article-info-block">
                                    <span>${read_time}</span>
                                    <span>${date}</span>
                                </div>
                                <a href="${url}">${title}</a>
                                <div class="blog-article-description">
                                    ${short_description}
                                </div>
                                <a href="${url}" class="mobile-hidden">
                                    <button class="btn btn-primary default-button">
                                        <div class="blog-button-read">
                                            ${blog_read_btn}
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.16667 15.5833L13.75 11L9.16667 6.41663" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </button>
                                </a>
                            </div>
                            <div class="col-md-6 blog-article-image">
                                <div class="blog-article-image-block">
                                    <img src="/storage/blog/main/${image}" alt="${alt}">
                                    ${dots}
                                </div>
                            </div>
                            ${dots}
                            <a href="${url}" class="desktop-hidden">
                                <button class="btn btn-primary default-button">
                                    <div class="blog-button-read">
                                        ${blog_read_btn}
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.16667 15.5833L13.75 11L9.16667 6.41663" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </button>
                            </a>
                        </div>`;

                    $('.blog-articles-container').append(html);
                }
            }
        });
    });

    $(document).on('click', '.portfolio-tab-trigger', function() {

        if (!$(this).hasClass('active-portfolio-tab')) {
            $('.portfolio-project-container').css('opacity', 0);
            $('.active-portfolio-tab').removeClass('active-portfolio-tab');
            $(this).addClass('active-portfolio-tab');
            $.ajax({
                url: "/portfolio/filter",
                type: "POST",
                data: {
                    tag: $(this).text()
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
                },
                success: function (response) {
                    $('.portfolio-project-container').html(response);
                    setTimeout(function() {
                        $('.portfolio-project-container').css('opacity', 1);
                    }, 500);
                },
                error: function (data) {

                }
            });
        }
    })

    $(document).on('click', '.main-page-blog-tab', function() {

        if (!$(this).hasClass('active-portfolio-tab')) {
            /*$('.portfolio-project-container').css('opacity', 0);*/
            $('.active-portfolio-tab').removeClass('active-portfolio-tab');
            $(this).addClass('active-portfolio-tab');
            $.ajax({
                url: "/blog/filter",
                type: "POST",
                data: {
                    category: $(this).attr('category'),
                    lang: $('html').attr('lang')
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
                },
                success: function (response) {
                    $('.blog-slider-container').html(response);
                    new Swiper(".main-blog-slider", {
                        slidesPerView: "auto"
                    });
                    /*setTimeout(function() {
                        $('.blog-slider-container').css('opacity', 1);
                    }, 500);*/
                },
                error: function (data) {

                }
            });
        }
    })
})
